import BaseService from "./BaseService";

export default class TrocaTurmaService extends BaseService {

  constructor(self) {
    super(self);
  }

  ObterTrocaTurma(parameters) {
    return this.ExecutaFetch("/api/TrocaTurma/ObterTrocaTurma", "POST", parameters);
  }

  ListaTurmasPorEspecialidade(codigoEspecialidade) {
    return this.ExecutaFetch("/api/TrocaTurma/ListaTurmasPorEspecialidade?codigoEspecialidade=" + codigoEspecialidade, "GET");
  }

  TrocaTurmaEspecialidade(parameters) {
    return this.ExecutaFetch("/api/TrocaTurma/TrocaTurmaEspecialidade", "POST", parameters);
  }
}